import React, { useState, useEffect } from 'react';
import { StateContext } from '../../common/contexts';
import { BAU } from '../../common/plans_data';
import { Router,  initialState } from './router';

const { plans, allPlansInclude } = BAU;

const DesktopBAU = () => {
  const [ path, updatePath ] = useState(initialState);
  useEffect(() => {
    const main = document.querySelector(".main-content");
    main.className = `${main.className} -bau`;
  }, []);
  return (
    <StateContext.Provider value={ [ path, updatePath ] }>
      <Router plans={ plans } allPlansInclude={ allPlansInclude } />
    </StateContext.Provider>
  );
};

export default DesktopBAU;
